<template>
  <div class="questions">
    <div v-if="map[qData.question_type] == 'instructions'">
      <br/>
      <h5><strong>{{qData.prompt}}.</strong></h5>
      <br/>
    </div>
    <div v-else>
      <label for="">{{qData.prompt}}: <div class="asterisk" v-if="qData.validation && qData.validation.required">*</div></label>
      <div v-if="map[qData.question_type] == 'textarea'">
        <textarea class="form-control" cols="60" rows="10" max-width="100%"
        :placeholder="qData.placeholder" :value="setValue()"
        :id="answer_increment? qData.answer.id.toString() + answer_increment: qData.answer.id"
        :categoryId="categoryId">
        </textarea>
      </div>
      <div v-else-if="map[qData.question_type] == 'file'">
        <FileUpload :question="qData" :categoryId="categoryId" />
      </div>
      <div v-else-if="map[qData.question_type] == 'radio'">
        <Radio :question="qData" :categoryId="categoryId" />
      </div>
      <div v-else-if="map[qData.question_type] == 'checkbox'">
        <Checkbox :question="qData" :categoryId="categoryId" />
      </div>
      <div v-else-if="map[qData.question_type] == 'select'">
        <Select :question="qData" :answer_increment="answer_increment" :multipleIndex="multipleIndex" :categoryId="categoryId" />
      </div>
      <div v-else>
        <input class="form-control"
        :type="setType()" :value="setValue()" :placeholder="qData.placeholder? qData.placeholder: ''"
        :id="answer_increment? qData.answer.id.toString() + answer_increment: qData.answer.id"
        :categoryId="categoryId">
      </div>
    </div>
    <div class="inline-errors" v-if="started && qData.answer.errors">
        <div v-for="(error, index) in errDisplay()" :key="index">
          <p>{{error}}</p>
        </div>
    </div>
    <div v-if="qData.help_text" class="help-text-section">
      <span class="help-text">{{qData.help_text}}</span>
    </div>
  </div>
</template>

<script>
import FileUpload from './FileUpload.vue'
import Radio from './Radio.vue'
import Checkbox from './Checkbox.vue'
import Select from './Select.vue'
export default {
  props:{
    qData: Object,
    started: Boolean,
    //profile_answer: String,
    answer_increment: String,
    multipleIndex: Number,
    categoryId: Number
  },
  components:{
    FileUpload,
    Radio,
    Checkbox,
    Select
  },
  data(){
    return{
      map:{
        "short_text": "text",
        "check_box": "checkbox",
        "multiple_choice": "radio",
        "long_text": "textarea",
        "file_upload": "file",
        "select": "select",
        "instructions": "instructions"
      },
      answer_value: ""
    }
  },
  methods:{
    setValue() {
      if (typeof(this.$props.qData.answer.value) === 'object') {
        if (this.$props.multipleIndex) {
          //use the saved value for this answer instance
          return this.$props.qData.answer.value[this.$props.multipleIndex].value
        } else {
          //use the blank "default" value until we save this instance
          return this.$props.qData.answer.value[0].value
        }
      } else {
        return this.$props.qData.answer.value
      }
    },
    setType() {
      if (!this.$props.qData.validation) {
        return "text"
      } else if (this.$props.qData.validation.email) {
        return "email"
      } else if (this.$props.qData.validation.phone) {
        return "tel"
      } else {
        return "text"
      }
    },
    errDisplay() {
      if (this.$props.qData.repeatable) {
        var errors = []
        for (var err in this.$props.qData.answer.errors) {
          var error = this.$props.qData.answer.errors[err]
          if (error[error.length - 1] === this.$props.answer_increment) {
            errors.push(error.slice(0, -1))
          }
        }
        return errors
      } else {
        return this.$props.qData.answer.errors
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.questions{
  box-sizing: border-box;
}

.questions div textarea{
  width: 365px;
  height: 165px;
}

.inline-errors {
  color: red;
}


.help-text {
  color: #A9A9A9;
}

.help-text-section {
  margin-bottom: 10px;
}

.asterisk {
  display: inline-block;
  font-weight: lighter;
}

</style>
